import { ReactNode, MouseEvent } from 'react';
import { cx } from '@linaria/atomic';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { NakedButton } from '../../../naked';
import { tabItemStyle } from './styles';

type Props = CommonHTMLButtonAttributes & {
  children: ReactNode;
  id: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  trackingId?: string;
};

export const Tab = ({ children, className, ...rest }: Props) => {
  return (
    <NakedButton className={cx(tabItemStyle, className)} {...rest}>
      {children}
    </NakedButton>
  );
};
